import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { SectionProps } from '../../types/types';

// Animation variants for the section
const sectionVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.8,
      when: "beforeChildren",
      staggerChildren: 0.2
    } 
  }
};

// Animation variants for the section title
const titleVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.5
    }
  }
};

const Section: React.FC<SectionProps> = ({ id, title, children, className }) => {
  return (
    <StyledSection
      id={id}
      as={motion.section}
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      className={className}
    >
      <div className="container">
        {title && (
          <SectionTitle
            as={motion.h2}
            variants={titleVariants}
          >
            {title}
          </SectionTitle>
        )}
        <SectionContent>{children}</SectionContent>
      </div>
    </StyledSection>
  );
};

const StyledSection = styled(motion.section)`
  padding: ${({ theme }) => theme.spacing.xxl} 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.xl} 0;
  }
`;

const SectionTitle = styled(motion.h2)`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 4px;
    background: ${({ theme }) => theme.colors.accent1};
  }
`;

const SectionContent = styled.div`
  width: 100%;
`;

export default Section; 